/**
 * Created by andrey on 08.08.2025
 */

cc.BezierTo = function (duration, config) {
    cc.BezierBy.prototype.constructor.call(this);
    
    this._toConfig = [];

    if (config !== undefined) {
        this.initWithDuration(duration, config);
    }
};

cc.BezierTo.prototype = Object.assign(Object.create(cc.BezierBy.prototype), {
    constructor: cc.BezierTo,

    initWithDuration: function (t, c) {
        if (cc.ActionInterval.prototype.initWithDuration.call(this, t)) {
            this._toConfig = c;
            return true;
        }
        return false;
    },

    startWithTarget: function (target) {
        cc.BezierBy.prototype.startWithTarget.call(this, target);
        const locStartPos = this._startPosition;
        const locToConfig = this._toConfig;
        const locConfig = this._config;

        locConfig[0] = cc.pSub(locToConfig[0], locStartPos);
        locConfig[1] = cc.pSub(locToConfig[1], locStartPos);
        locConfig[2] = cc.pSub(locToConfig[2], locStartPos);
    }
});

cc.bezierTo = (duration, config) => new cc.BezierTo(duration, config);
